import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export const DashboardSectionTitle = ({ icon, children, sx }) => (
  <Stack
    direction="row"
    spacing={1}
    sx={{
      alignItems: 'center',
      color: 'primary.main',
      ...sx,
    }}
  >
    <Box sx={{ display: 'inline-flex', flex: '0 0 auto' }}>
      {React.cloneElement(icon, { fontSize: 'small' })}
    </Box>
    <Typography variant="h3" sx={{ color: 'inherit' }}>
      {children}
    </Typography>
  </Stack>
);
